<template>
  <v-card class="shadowCard tarjeta-tiempo">
    <v-card-text class="pa-4">
      <div class="d-flex align-center justify-center mb-4">
        <v-avatar size="38" color="indigo lighten-5" class="mr-3">
          <v-icon color="indigo darken-1" small>mdi-account-clock-outline</v-icon>
        </v-avatar>
        <div class="text-subtitle-1 font-weight-bold text-truncate black--text">
          {{ nombre || 'N/A' }}
        </div>
      </div>

      <v-row dense>
        <v-col cols="12">
          <div class="tiempo-bloque">
            <div class="tiempo-label indigo--text text--darken-1">
              <v-icon x-small color="indigo darken-1" class="mr-1">mdi-clock-start</v-icon>
              Hora de inicio
            </div>
            <div v-if="partesInicio" class="tiempo-reloj">
              <span class="tiempo-digito">{{ partesInicio.h }}</span>
              <span class="tiempo-sep">:</span>
              <span class="tiempo-digito">{{ partesInicio.m }}</span>
              <span v-if="partesInicio.s != null" class="tiempo-sep">:</span>
              <span v-if="partesInicio.s != null" class="tiempo-digito tiempo-digito--seg">{{ partesInicio.s }}</span>
            </div>
            <div v-else class="tiempo-na">{{ horaInicio || 'N/A' }}</div>
          </div>
        </v-col>

        <v-col cols="12">
          <div class="tiempo-bloque" :class="{ 'tiempo-bloque--live': enActividad }">
            <div class="tiempo-label green--text text--darken-2">
              <v-icon x-small color="green darken-1" class="mr-1">mdi-timer-outline</v-icon>
              Tiempo actividad
            </div>
            <div v-if="partesActividad" class="tiempo-reloj tiempo-reloj--activo">
              <span class="tiempo-digito">{{ partesActividad.h }}</span>
              <span class="tiempo-sep">:</span>
              <span class="tiempo-digito">{{ partesActividad.m }}</span>
              <span v-if="partesActividad.s != null" class="tiempo-sep">:</span>
              <span v-if="partesActividad.s != null" class="tiempo-digito tiempo-digito--seg">{{ partesActividad.s }}</span>
            </div>
            <div v-else class="tiempo-na">{{ tiempoActividad || 'N/A' }}</div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TarjetaTiempoActividad',

  props: {
    nombre: { type: String, default: '' },
    horaInicio: { type: String, default: '' },
    tiempoActividad: { type: String, default: '' },
  },

  computed: {
    partesInicio() {
      return this.parsearTiempo(this.horaInicio)
    },
    partesActividad() {
      return this.parsearTiempo(this.tiempoActividad)
    },
    enActividad() {
      return !!this.partesActividad
    },
  },

  methods: {
    parsearTiempo(valor) {
      if (valor == null || valor === '' || valor === 'N/A') return null
      const s = String(valor).trim()
      const conSeg = s.match(/^(\d{1,2}):(\d{2}):(\d{2})$/)
      if (conSeg) {
        return {
          h: conSeg[1].padStart(2, '0'),
          m: conSeg[2],
          s: conSeg[3],
        }
      }
      const sinSeg = s.match(/^(\d{1,2}):(\d{2})$/)
      if (sinSeg) {
        return {
          h: sinSeg[1].padStart(2, '0'),
          m: sinSeg[2],
          s: null,
        }
      }
      return null
    },
  },
}
</script>

<style scoped>
.tarjeta-tiempo {
  height: 100%;
}

.tiempo-bloque {
  background: #f7f8fc;
  border-radius: 12px;
  padding: 18px 12px 20px;
  text-align: center;
  border: 1px solid #eef0f6;
}

.tiempo-bloque--live {
  background: linear-gradient(180deg, #f3fff6 0%, #e8f8ee 100%);
  border-color: #c8ecd4;
}

.tiempo-label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}

.tiempo-reloj {
  display: flex;
  align-items: center;
  justify-content: center;
  font-variant-numeric: tabular-nums;
}

.tiempo-digito {
  background: #fff;
  color: #1a237e;
  font-size: 2.35rem;
  font-weight: 700;
  line-height: 1;
  padding: 12px 10px 11px;
  border-radius: 10px;
  min-width: 58px;
  box-shadow: 0 4px 10px rgba(26, 35, 126, 0.08);
}

.tiempo-reloj--activo .tiempo-digito {
  color: #1b5e20;
  box-shadow: 0 4px 10px rgba(27, 94, 32, 0.12);
}

.tiempo-digito--seg {
  font-size: 1.85rem;
  min-width: 50px;
  opacity: 0.85;
}

.tiempo-sep {
  font-size: 2.1rem;
  font-weight: 700;
  margin: 0 6px;
  color: #9fa8da;
  animation: blink-sep 1.2s ease-in-out infinite;
}

.tiempo-reloj--activo .tiempo-sep {
  color: #81c784;
}

.tiempo-na {
  font-size: 2rem;
  font-weight: 600;
  color: #9e9e9e;
  padding-top: 8px;
}

@keyframes blink-sep {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.25; }
}
</style>
